<template>

    <div class="box">
        <!-- <div class="is-size-3">Measure</div> -->
        <!-- is-vcentered -->
        <!--
		<div class="is-size-3">Přehled</div>
        -->
        <div class="columns is-hcentered">
            <div class="column is-4">

                <div class="box">
                    <table class="table" width="100%">
                        <tbody>
                            <tr>
                                <td class="my-td-vam has-text-weight-bold has-text-left"> 
                                    {{ info?.setup?.descr || '' }}
                                </td>
                                <td class="my-td-vam has-text-right">
                                    <p class="control">
                                        <button 
                                            class="button is-small is-active"
                                            @click="UserWatchingModeClick()">
                                            <i class="mdi mdi-tray-arrow-down mdi-24px" >{{ refreshCnt.toString().padStart(2,'0') }}</i>
                                        </button>
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
				</div>

				<span class="has-text-white">age: {{ getDataAge() }}</span>
				<div class="box has-text-left" v-if="IsDataOutOfDate() || IsDataError()">
					<ul class="">

						<li  v-if="IsDataOutOfDate()" class="pb-1">
							<span class="tag is-danger is-light is-small">
								<i class="mdi mdi-alert-circle-outline mdi-18px has-text-danger"></i>
								&nbsp;Pozor data z instalace jsou starší než {{ FormatSecHuman(getDataAge()) }}
							</span>
						</li>

						<template v-for="(v,k) in dataErrors" :key="k">
                            <li class="pb-1">
                                <span class="tag is-danger is-light is-small">
                                    <i class="mdi mdi-alert-circle-outline mdi-18px has-text-danger"></i>
                                    &nbsp;{{ v.err }} (err: {{ v.code }},dev: {{ v.devid }})
                                </span>
                            </li>
						</template>


					</ul>
				</div>

                <div class="box">

                    <table class="table" width="100%">
                        <tbody>
							
							<tr>
                                <td class="my-td-vam has-text-left p-0"> 
                                    <i class="mdi mdi-factory mdi-24px has-text-primary"></i>
                                </td>
                                <td class="my-td-vam has-text-left my-line-h1"> 
                                    Dnes vyrobeno
									<span v-if="IsUiModeExt1">
										<br/>
										<span class="is-size-7">DAY: {{ dataSe?.sum_last?.data?.sum?.IN_DAY_W }} T: {{ dataSe?.sum_last?.data?.sum?.IN_TOT_KWH }} ({{ dataSe?.sum_last?.data?.sum?.IN_TOT_RAW_KWH }}) </span>
									</span>
                                </td>
                                <td class="my-td-vam has-text-weight-bold has-text-right is-size-4">
									{{ FormatBigNumToday(new Number((dataSe?.sum_last?.data?.sum?.IN_DAY_W || 0) / 1000).toFixed(2)) }}
                                </td>
                                <td class="my-td-vam has-text-left">kWH</td>
                            </tr>

                            <tr>
                                <td class="my-td-vam has-text-left p-0"> 
                                    <i class="mdi mdi-solar-power-variant-outline mdi-24px has-text-warning"></i>
                                </td>
                                <td class="my-td-vam has-text-left my-line-h1">
                                    Aktuální výroba
                                </td>
                                <td class="my-td-vam has-text-weight-bold has-text-right is-size-4">
									{{ FormatBigNumInst(new Number((dataSe?.sum?.data?.sum?.IN_S_W || 0 ) / 1000).toFixed(2)) }}
                                </td>
                                <td class="my-td-vam has-text-left">kW</td>
							</tr>

                            <tr>
                                <td class="my-td-vam has-text-left p-0"> 
                                    <i class="mdi mdi-battery-50 mdi-24px has-text-info"></i>
                                </td>
                                <td class="my-td-vam has-text-left my-line-h1">
									Baterie
									<br/>
									<span v-if="!IsDataOutOfDate()">
										<i v-show="Math.abs(batPwr) > 0"
											:class="[batPwr > 0 ? 'has-text-success mdi-arrow-right' : 'has-text-danger mdi-arrow-left']"
											class="mdi mdi-16px"
										></i>
										<span v-show="Math.abs(batPwr) > 0" >
											<span 
												class="is-size-7 has-text-right"
											>
												{{ new Number(batPwr/1000).toFixed(2) }}&nbsp;kW
											</span>
										</span>
										<span v-if="IsUiModeExt1">
											<br/>
											<span class="is-size-7">
												OFF: {{ dataSe?.sum_last?.data?.sum?.BM_THR_LO_OFF }} 
												AC: {{ dataSe?.sum_last?.data?.sum?.BM_THR_LO_ACCH }} 
												SU: {{ dataSe?.sum_last?.data?.sum?.BM_THR_LO_STOP_USE }} 
												H: {{ dataSe?.sum_last?.data?.sum?.BM_THR_HI }} 
											</span>
										</span>
									</span>

                                </td>
								<td class="my-td-vam has-text-weight-bold has-text-right is-size-4">
									{{ FormatBigNumToday(new Number(dataSe?.sum?.data?.sum?.BM_SOC_P || 0).toFixed(2)) }}
                                </td>
                                <td class="my-td-vam has-text-left">%</td>
                            </tr>

                            <tr>
                                <td class="my-td-vam has-text-left p-0"> 
                                    <i class="mdi mdi-transmission-tower-export mdi-24px has-text-danger"></i>
                                </td>
                                <td class="my-td-vam has-text-left my-line-h1">
									Import

									<span v-if="IsUiModeExt1" class="has-text-right">
										<br/>
										<span class="is-size-7">iBAK: {{ curLoadW.IN_ACO_W }} kW eCUR: {{ curLoadW.EM_PWR_W }} (R:{{ curLoadW.EM_PWR_R_W }} S:{{ curLoadW.EM_PWR_S_W }} T:{{ curLoadW.EM_PWR_T_W }} )</span>
									</span>
                                </td>
                                <td class="my-td-vam has-text-weight-bold has-text-right is-size-4">
									{{ FormatBigNumToday(new Number(this.emTodayKwh || 0).toFixed(2)) }}
                                </td>
                                <td class="my-td-vam has-text-left">kWH</td>
                            </tr>

                            <tr>
                                <td class="my-td-vam has-text-left p-0"> 
                                    <i class="mdi mdi-transmission-tower-import mdi-24px has-text-grey"></i>
                                </td>
                                <td class="my-td-vam has-text-left my-line-h1">
									Export
                                </td>
                                <td class="my-td-vam has-text-weight-bold has-text-right is-size-4">

									{{ FormatBigNumToday(new Number(this.emExportTodayKwh || 0).toFixed(2)) }}

                                </td>
                                <td class="my-td-vam has-text-left">kWH</td>
                            </tr>

                            <tr>
                                <td class="my-td-vam has-text-left p-0"> 
                                    <i class="mdi mdi-home-import-outline mdi-24px has-text-link"></i>
                                </td>
                                <td class="my-td-vam has-text-left my-line-h1">
									Spotřeba
									<span v-if="IsUiModeExt1">
										<br/>
										<span class="is-size-7">DAY: {{ FormatBigNumToday(new Number(loconDayKwh).toFixed(2)) }} kWH</span>
									</span>
                                </td>
                                <td class="my-td-vam has-text-weight-bold has-text-right is-size-4">

									{{ FormatBigNumToday(new Number((dataSe?.sum_last?.data?.sum?.LOCON_W || 0)/1024).toFixed(2)) }}

                                </td>
                                <td class="my-td-vam has-text-left">kW</td>
                            </tr>

                        </tbody>
                    </table>


				</div>

                <div class="box"  v-if="IsUiModeExt1">
					<span class="tag mr-1 is-rounded is-small" title="Allow PV to charger battery">PVCH : {{ GetFlag('IN_PVCH_F') }}</span>
					<span class="tag mr-1 is-rounded is-small" title="Allow AC to charger battery">ACCH : {{ GetFlag('IN_ACCH_F') }}</span>
					<span class="tag mr-1 is-rounded is-small" title="Allow to feed-in the Grid">FIG : {{ GetFlag('IN_FIG_F') }}</span>
					<span class="tag mr-1 is-rounded is-small" title="Allow battery to discharge when PV is available">BDLPVA : {{ GetFlag('IN_BDLPVA_F') }}</span>
					<span class="tag mr-1 is-rounded is-small" title="Allow battery to discharge when PV is unavailable">BDLPVU : {{ GetFlag('IN_BDLPVU_F') }}</span>
					<span class="tag mr-1 is-rounded is-small" title="Allow battery to feed-in to the Grid when PV is available">BDGPVA : {{ GetFlag('IN_BDGPVA_F') }}</span>
					<span class="tag mr-1 is-rounded is-small" title="Allow battery to feed-in to the Grid when PV is unavailable">BDGPVU : {{ GetFlag('IN_BDGPVU_F') }}</span>

				</div>

                <div class="box">
                    <table class="table" width="100%">
                        <tbody>
							<tr><td class="has-text-left">Aktuální čas</td><td class="has-text-right">
									<span class="has-text-weight-bold">{{ timeNow[0] }}</span><br/> {{timeNow[1]}} 
							</td></tr>

                        </tbody>
                    </table>
				</div>


            </div>
            <div class="column is-8">

                <div class="box">
                    <div class="field is-grouped is-grouped-multiline">
                        <p class="control">
                            <button class="button" @click="ChValClick('g_in_tot_kwh')" :class="[ chart_value=='g_in_tot_kwh' ? 'is-primary' : '' ]">Výroba</button>
                        </p>
                        <p class="control">
                            <button class="button" @click="ChValClick('g_bat_proc')" :class="[ chart_value=='g_bat_proc' ? 'is-primary' : '' ]">Baterie</button>
                        </p>
                        <p class="control">
                            <button class="button" @click="ChValClick('g_em_tot_kwh')" :class="[ chart_value=='g_em_tot_kwh' ? 'is-primary' : '' ]">Import</button>
                        </p>
                        <p class="control">
                            <button class="button" @click="ChValClick('g_em_tot_exp_kwh')" :class="[ chart_value=='g_em_tot_exp_kwh' ? 'is-primary' : '' ]">Export</button>
                        </p>
                        <p class="control">
                            <button class="button" @click="ChValClick('g_locon_wh')" :class="[ chart_value=='g_locon_wh' ? 'is-primary' : '' ]">Spotřeba</button>
                        </p>
                    </div>
                </div>

                <div class="box">
                    <div class="field has-addons">
                        <p class="control">
                            <button class="button" @click="ChIntClick('HO')" :class="[ chart_interval=='HO' ? 'is-info' : '' ]">Hodiny</button>
                        </p>
                        <p class="control">
                            <button class="button" @click="ChIntClick('DA')" :class="[ chart_interval=='DA' ? 'is-info' : '' ]">Dny</button>
                        </p>
                        <p class="control">
                            <button class="button" @click="ChIntClick('MO')" :class="[ chart_interval=='MO' ? 'is-info' : '' ]">Měsíce</button>
                        </p>
                        <p class="control">
                            <button class="button" @click="ChIntClick('YE')" :class="[ chart_interval=='YE' ? 'is-info' : '' ]">Roky</button>
                        </p>
                    </div>
                    <div class="has-text-left" v-if="IsUiModeExt1" >
                        <label class="checkbox">
                            <input type="checkbox"  v-model="chartLabelsEnabled" @change="ChLabelsEnabledChange"/>
                            Labels
                        </label>
						&nbsp;
                        <label class="checkbox">
                            <input type="checkbox"  v-model="chartShowAllData" @change="ChShowAllDataChange"/>
                            All data
                        </label>
                    </div>


                    <div ref="chart" :style="{ height: chartHeight + 'px' }"></div>
					
					<div>
					<button class="button" @click="ChartFirstClick" >
							<i class="mdi mdi-24px mdi-page-first"></i>
					</button>
					&nbsp;
					<button class="button" @click="ChartLeftClick" >
							<i class="mdi mdi-24px mdi-chevron-left"></i>
					</button>
					&nbsp;
					<button class="button" @click="ChartRightClick" >
							<i class="mdi mdi-24px mdi-chevron-right"></i>
					</button>
					&nbsp;
					<button class="button" @click="ChartLastClick" :class="[ chartScrollFlag ? 'has-text-info' : '' ]" >
							<i class="mdi mdi-24px mdi-page-last"></i>
					</button>

					</div>
					<br/>

                    <!--
                    <div class="has-text-left is-size-7 ">*) the charts are not updated in "Standby mode"</div>
                    -->
					<div v-if="IsUiModeExt1" class="has-text-right">
						<template v-for="(v,k) in dataSe?.status?.devs" :key="k">
							<span 
								class="tag mr-1 is-rounded is-small"
								:class="[ v.error == 0 ? 'is-success' : 'is-danger' ]"
								:title="GetDevErrorInfo(k)">
								{{ k }}
							</span>
						</template>

						<span class="tag is-danger is-light" v-show="isSeSumError">data err</span>
						<span class="tag is-warning" v-show="getSeDataErrors > 0" title="Data err cnt">de: {{ getSeDataErrors }}</span>
						<div class="is-italic tag is-small" title="Data CM">

							[ {{ dataSe?.sum?.data?.TM || '?' }} &nbsp;{{ NowDiffSec(this.dataSe?.sum?.data?.TM) || '?' }}] 
							
							&nbsp;
							
							<i 
								title="Collector připojení (klikem obnovit)"
								@click="UserWatchingModeClick()"
								class="mdi mdi-24px" 
								:class="[ ctrlError ? 'mdi-link-off has-text-danger' : 'mdi-link' ]"
							></i>

							&nbsp;

							<i 
								title="Připojení do elektrické sítě"
								class="mdi mdi-24px" 
								:class="[ isGrid == -1 ? 'mdi-alert has-text-danger' : (isGrid == 0 ? 'mdi-power-plug-off-outline has-text-danger' : 'mdi-power-plug-outline') ]"
							></i>
						</div>
						<div class="box has-text-left is-size-6" v-if="false && debugConsole.length > 0">
                            <button class="button" @click="debugConsole = ''" >Clear</button>
							<textarea v-model="debugConsole" style="width: 100%;" rows="10">
							</textarea>
						</div>
					</div>

                </div>
            </div>
        </div>
    </div>

</template>

<script>

import { store } from '../store.js'
import ApexCharts from 'apexcharts';
import { libapi } from '../libapi.js'
import { tmblk } from '../tmblk.js'

const DATA_INTERVAL_DEFAULT = 30
const CHART_TYPE_MY_LINE = "myLine"
const CHART_TYPE_MY_BAR = "myBar"
const CHART_TYPE_MY_AREA = "myArea"
const SHOW_ERROR_SEC = 60

const ZOOM_LEFT = 'L'
const ZOOM_RIGHT = 'R'
const ZOOM_FIRST = 'F'
const ZOOM_LAST = 'A'

export default {
    name: 'AppDashboard',
    data : function() {
        return {
            refreshCnt : 0,
            dataInterval : DATA_INTERVAL_DEFAULT,
			// user watching duration (jak dlouho trva zrychlene obnovovani dat)
            uwDuration : 0,
            cntTo : null,
            chart_interval : 'HO',
            chart_value : 'g_in_tot_kwh',


            dataInfo : null,
            dataSe : {},
            // vypocitane chyby v datech
            // null - znamena ze je jeste neinicializovany
            dataErrors : null,
            // kdy se objevil error
            dataErrorsTs : new Date(),
            
			// invertor dnes kwh
            inTodayKwh : 0,
			// elektromer import dnes kwh
            emTodayKwh : 0,
            emExportTodayKwh : 0,
            loconDayKwh : 0,
            timeNow : '',
			ctrlError : false,

            chart: null,
            chartHeight: 350,
            chartLabelsEnabled: false,
			chartShowAllData: false,
			chartCurDef : {},
			chartScrollFlag : false,

			debugConsole : '',

        }
    },
    computed : {
		IsUiModeExt1 : function() {
			return store.IsUiModeExt1()
		},
		info : function() {
            return store.info
        },
		isErrorApp : function() {
            let err = store.error_app 
            return (err !== null && err != "")
        },
		getSeDataErrors : function() {
			if ( this.dataSe === null || Object.keys(this.dataSe).length == 0 ) {
				return 99
			}
			let errCnt = 0
			for (const k in this.dataSe) {
				const v = this.dataSe[k]
				const isObj = typeof v === 'object' && v !== null
				if ( !isObj ) errCnt++
			}
			return errCnt
		},
		isSeSumError : function() {
			if ( this.dataSe === null ) return false
			const err = this.dataSe?.sum_last?.head?.error || null
			return err !== null
		},
		curLoadW : function() {

			const ret = {
				IN_ACO_W : new Number((this.dataSe?.sum?.data?.sum?.IN_ACO_W || 0)/1000).toFixed(2),
				EM_PWR_W : new Number((this.dataSe?.sum?.data?.sum?.EM_PWR_W || 0)/1000).toFixed(2),
				EM_PWR_R_W : new Number((this.dataSe?.sum?.data?.sum?.EM_PWR_R_W || 0)/1000).toFixed(2),
				EM_PWR_S_W : new Number((this.dataSe?.sum?.data?.sum?.EM_PWR_S_W || 0)/1000).toFixed(2),
				EM_PWR_T_W : new Number((this.dataSe?.sum?.data?.sum?.EM_PWR_T_W || 0)/1000).toFixed(2),
			}
			return ret
			//return [new Number(em_w / 1000).toFixed(2),new Number(in_w / 1000).toFixed(2)]
			/*
			if ( em_w > 0 ) {
				return [new Number(em_w / 1000).toFixed(2),"EM",new Number(in_w / 1000).toFixed(2),"IN"]
			}
			return [new Number(in_w / 1000).toFixed(2),"IN"]
			 */
		},
		batPwr : function() {
			return this.dataSe?.sum?.data?.sum?.BM_CHG_W || 0
			/*
			const chg_i = this.dataSe?.sum?.data?.sum?.BM_CHG_I || 0
			const bat_v = this.dataSe?.sum?.data?.sum?.BM_BAT_V || 0
			return chg_i * bat_v
			 */
		},
		isGrid : function() {
			const ig = this.dataSe?.sum_last?.data?.sum?.IS_GRID_F
			if ( ig === undefined ) return -1
			return new Number(ig)
		},
    },
    methods: {
		getDataAge : function() {
			return this.NowDiffSec(this.dataSe?.sum?.data?.TM) || -1
		},

        // toto se pouziva na zjisteni aktualnosti dat okamzitych (aktualni vyroba)
		IsDataOutOfDate : function() {
			return this.getDataAge() > 60*10
		},

        // funkce pouziva SHOW_ERROR_SEC k uvodnimu pozdrzeni zobrazeni chyb pokud vzniknou
        // a pak uklada stav do localStorage aby pri refresh a dlouho trvajici chybe
        // uz chybu zobrazila hned
        IsDataError : function() {
            // pokud je neinicializovany ignorujeme protoze jeste nemame data
            // jinak by se zmazal priznak v localStorage
            if ( this.dataErrors === null ) {
                return false
            }
            const lsShowDataError = 'ShowDataError'
            if ( this.dataErrors.length > 0 ) {
                const now = new Date()
                const diff = ( now - this.dataErrorsTs ) / 1000
                const lsVal = localStorage.getItem(lsShowDataError);
                if ( lsVal !== null ) {
                    return true
                }
                if ( diff > SHOW_ERROR_SEC ) {
                    localStorage.setItem(lsShowDataError, "1");
                    return true
                }
            } else {
                    localStorage.removeItem(lsShowDataError);
            }
            return false
        },

		// pokud jsou data z minuleho dne
		IsDataFromToday : function() {
			const val = this.dataSe?.sum?.data?.TM || -1
			if ( val == -1 ) return false
			const dt = this.GetDateFromStrUTC(val)
			if ( !dt ) return false
			const d1 = new Date().getDate()
			const d2 = dt.getDate()
			return d1 == d2
		},

		FormatBigNumInst : function(val) {
			if ( this.IsDataOutOfDate() ) {
				return "--.--"
			}
			return val
		},

		FormatBigNumToday : function(val) {
			if ( !this.IsDataFromToday() ) {
				return "--.--"
			}
			return val
		},

		FormatSecHuman : function (seconds) {
			if (seconds >= 86400) { 
				const days = Math.floor(seconds / 86400);
				if ( days == 1 ) return `${days} den`
				if ( days < 5 ) return `${days} dny`
				return `${days} dnů`
			} else if (seconds >= 3600) { 
				const hours = Math.floor(seconds / 3600);
				if ( hours == 1) return `${hours} hodina`
				if ( hours < 5) return `${hours} hodiny`
				return `${hours} hodin`
			} else if (seconds >= 60) { 
				const minutes = Math.floor(seconds / 60);
				if ( minutes == 1) return `${minutes} minuta`
				if ( minutes < 5) return `${minutes} minuty`
				return `${minutes} minut`
			} else {
				if ( seconds == 1) return `${seconds} vteřina`
				if ( seconds < 5) return `${seconds} vteřiny`
				return `${seconds} vteřin`
			}
		},

		GetDateFromStrUTC : function( stm ) {
			if ( !stm ) return false
			// replace kuli iOS
			stm = stm.replace(" ","T")
			// toto nefunguje na iOS
			//const targetDate = new Date(tmData + ' UTC');
			// takto to funguje i na iOS

			let dt
			if ( ! stm.endsWith("Z") ) {
				dt = new Date(stm + 'Z');
			} else {
				dt = new Date(stm);
			}
			return dt
		},

		NowDiffSec : function( stm ) {
			let dt = this.GetDateFromStrUTC(stm)
			if ( !dt ) return false
			const now = new Date();
			const diffInMilliseconds = now - dt;
			const diffInSeconds = Math.floor(diffInMilliseconds / 1000);
			return diffInSeconds
		},

        GetFlag : function(flag) {
			const fl = this.dataSe?.sum_last?.data?.sum?.[flag] || "?"
			return fl
		},

        GetDevErrorInfo : function(dev_id) {
			// error z status
			let stat = this.dataSe?.status?.devs[dev_id] || false
			if ( !stat ) {
				return "dev_id :" + dev_id + " not found."
			}
			// driver error ze sum
			const sumErr = this.dataSe?.sum_last?.data?.devs?.[dev_id]?.error || ""
			if ( stat.error == 0 && sumErr === "" ) {
				return "(" + dev_id + ") " + stat.info
			}
			return "(" + dev_id + ") " + stat.info + " error: " + stat.error + " \"" + sumErr + "\""
		},
        GetNow : function() {
            let date = new Date()
            const hours = String(date.getHours()).padStart(2, '0') // HH
            const minutes = String(date.getMinutes()).padStart(2, '0') // mm
            const seconds = String(date.getSeconds()).padStart(2, '0') // ss
            const day = String(date.getDate()).padStart(2, '0') // DD
            const month = String(date.getMonth() + 1).padStart(2, '0') // MM (měsíc je 0-indexovaný)
            const year = date.getFullYear() // YYYY

            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const timeZoneOffset = -date.getTimezoneOffset();
            const sign = timeZoneOffset >= 0 ? '+' : '-';
            const offsetHours = String(Math.floor(Math.abs(timeZoneOffset) / 60)).padStart(2, '0');
            const offsetMinutes = String(Math.abs(timeZoneOffset) % 60).padStart(2, '0');
            const offset = `${sign}${offsetHours}${offsetMinutes}`;

            return [`${hours}:${minutes}:${seconds} ${day}.${month}.${year}`,`${offset} (${timeZone})`]
        },
		ChartBase: function( myType, series, xmin, xmax, ymin, ymax, tooltipSuffix,labelFmt, dataLabels) {
			let chartOptions = {
				chart: {
					type: series[0].type,
					height: this.chartHeight,
					animations: {
						enabled: false,
					},
					zoom: {
						enabled: true, // Povolit zoom
						type: 'x',     // Zoom pouze na ose X
						autoScaleYaxis: true
					},
					toolbar : {
						show : false,
						tools: {
							pan: true, // Povolit režim posunu
							zoom: true // Povolit režim zoomu
						},
						autoSelected: 'pan', // Výchozí režim je posun (pan)
					},
					events: {
						/*
						zoomed: (chartContext, { xaxis }) => {

							const minDate = new Date(xaxis.min);
							const maxDate = new Date(xaxis.max);

							console.log("Min (timestamp):", xaxis.min);
							console.log("Max (timestamp):", xaxis.max);

							console.log("Min (formatted):", minDate.toLocaleString());
							console.log("Max (formatted):", maxDate.toLocaleString());
						}
						 */
					},
				},
				//colors: ['#008FFB', '#107FDB'],
				dataLabels: {
					enabled: false 
				},
				fill: {
					//opacity: [0.24, 1]
				},
				grid: {
					row: {
						colors: ['#f3f3f3', 'transparent'], 
						opacity: 0.5
					}
				},
				series: series,
				xaxis: {
					type: 'datetime',
					min: xmin,
					max: xmax,
					labels: {
						formatter: function(value) {
							let date = new Date(value);
							if ( !isNaN(date.getTime())) {
								let day = String(date.getDate()).padStart(2, '0');
								let month = String(date.getMonth() + 1).padStart(2, '0'); // Měsíce jsou indexovány od 0
								let year = date.getFullYear();
								let hour = date.getHours();
								if (labelFmt == 'HO') {
									return `${day}.${month} ${hour}:00`
								} else if ( labelFmt == 'MO' ) {
									return `${month}.${year}`;
								} else if ( labelFmt == 'YE' ) {
									return `${year}`;
								}
								return `${day}.${month}.${year}`;
							} else {
								// toto pro rangeArea
								return value
							}
						}
					},
				},
				yaxis: {
					//min: 0,
					labels: {
						formatter: function(value) {
							if (labelFmt == 'HO') {
								return value 
							}
							return Math.round(value);
						}
					},
				},
				stroke: {
					//curve: 'smooth',
					curve: 'stepline',
					width: [0, 2],
				},
				tooltip: {
					y: {
						formatter: function(value) {
							return value + tooltipSuffix
						}
					}
				},
			}
			if ( ymin !== null ) {
				chartOptions.yaxis.min = ymin
			}
			if ( ymax !== null ) {
				chartOptions.yaxis.max = ymax
			}
			if ( dataLabels ) {
				chartOptions.dataLabels.enabled = true
			}
			if ( myType == CHART_TYPE_MY_LINE ) {
				chartOptions.colors = ['#008FFB']
				chartOptions.stroke.width = [4]
				chartOptions.fill.opacity = [1]
			} else if ( myType == CHART_TYPE_MY_BAR ) {
				chartOptions.dataLabels =  {
					enabled: true,
					formatter: function (val) {
						if ( val == "0" ) return ""
						return val
					},
					offsetY: -20,
					style: {
						fontSize: '10px',
						colors: ["#304758"]
					}
				}
				chartOptions.plotOptions = {
					bar: {
						borderRadius: 4,
						dataLabels: {
							position: 'top', // top, center, bottom
						},
					}
				}
			} else if ( myType == CHART_TYPE_MY_AREA ) {
				chartOptions.colors = ['#00E396', '#008FFB']
				chartOptions.stroke.width = [0,4]
				chartOptions.fill.opacity = [0.2,1]
				chartOptions.legend = { position: 'top' }
				chartOptions.dataLabels.enabled = dataLabels
				chartOptions.dataLabels.enabledOnSeries = [1]
			}
			return chartOptions
		},

        ShowChart: function() {

			this.ChartScrollStop()

            const def = {
                HO : {
                    blk : 'hours',
                    labelFmt : 'HO',
					zoomBlock : 24,
                    minusStep : tmblk.def.HO.minusStep,
                    plusStep : function(tm) {
                        tm.setHours(tm.getHours()+1)
                        return tm
					},

					zoomRngLeft : function(zoomType, tm) {
						if (zoomType == ZOOM_LEFT ) {
							const dt = new Date(tm)
							dt.setHours(0, 0, 0, 0)
							if (tm === dt.getTime()) {
								dt.setDate(dt.getDate() - 1)
							}
							return dt.getTime()
						} else if (zoomType == ZOOM_RIGHT) {
							const dt = new Date(tm)
							dt.setHours(0, 0, 0, 0)
							if (dt.getTime() === tm) {
								dt.setDate(dt.getDate() + 1)
							}
							return dt.getTime()
						} else if (zoomType == ZOOM_FIRST) {
							//const dt = new Date(tm)
							const dt = new Date(this._chTimeMin)
							dt.setHours(0, 0, 0, 0)
							return dt.getTime()
						} else if (zoomType == ZOOM_LAST) {
							//const dt = new Date(tm)
							const dt = new Date(this._chTimeMax)
							dt.setHours(0, 0, 0, 0)
							return dt.getTime()
						}
					},

					zoomRngRight : function(tm) {
						const dt = new Date(tm)
						dt.setDate(dt.getDate() + 1)
						return dt.getTime()
					},


                },
                DA : {
                    blk : 'days',
                    labelFmt : 'DT',
					zoomBlock : 31,
                    minusStep : tmblk.def.DA.minusStep,
                    plusStep : function(tm) {
                        tm.setHours(tm.getHours()+24)
                        return tm
                    },

					zoomRngLeft : function(zoomType, tm) {
						if (zoomType == ZOOM_LEFT ) {
							const dt = new Date(tm)
							dt.setDate(1);
							dt.setHours(0, 0, 0, 0)
							if (tm === dt.getTime()) {
								dt.setMonth(dt.getMonth() - 1);
							}
							return dt.getTime()
						} else if (zoomType == ZOOM_RIGHT) {
							const dt = new Date(tm)
							dt.setDate(1);
							dt.setHours(0, 0, 0, 0)
							if (dt.getTime() === tm) {
								dt.setMonth(dt.getMonth() + 1);
							}
							return dt.getTime()
						} else if (zoomType == ZOOM_FIRST) {
							//const dt = new Date(tm)
							const dt = new Date(this._chTimeMin)
							dt.setDate(1);
							dt.setHours(0, 0, 0, 0)
							return dt.getTime()
						} else if (zoomType == ZOOM_LAST) {
							//const dt = new Date(tm)
							const dt = new Date(this._chTimeMax)
							dt.setDate(1);
							dt.setHours(0, 0, 0, 0)
							return dt.getTime()
						}
					},

					zoomRngRight : function(tm) {
						const dt = new Date(tm)
							dt.setDate(1);
							dt.setHours(0, 0, 0, 0)
						dt.setMonth(dt.getMonth() + 1)
						return dt.getTime()
					},


                },
                MO : {
                    blk : 'months',
                    labelFmt : 'MO',
					zoomBlock : 12,
                    minusStep : tmblk.def.MO.minusStep,
                    plusStep : function(tm) {
                        const currentMonth = tm.getMonth();
                        if (currentMonth === 11) {
                            tm.setMonth(0)
                            tm.setFullYear(tm.getFullYear() + 1)
                        } else {
                            tm.setMonth(currentMonth + 1)
                        }
                        return tm;
                    },


					zoomRngLeft : function(zoomType, tm) {
						if (zoomType == ZOOM_LEFT ) {
							const dt = new Date(tm)
							dt.setDate(1);
							dt.setMonth(0);
							dt.setHours(0, 0, 0, 0)
							if (tm === dt.getTime()) {
								dt.setFullYear(dt.getFullYear() - 1);
							}
							return dt.getTime()
						} else if (zoomType == ZOOM_RIGHT) {
							const dt = new Date(tm)
							dt.setDate(1);
							dt.setMonth(0);
							dt.setHours(0, 0, 0, 0)
							if (dt.getTime() === tm) {
								dt.setFullYear(dt.getFullYear() + 1);
							}
							return dt.getTime()
						} else if (zoomType == ZOOM_FIRST) {
							//const dt = new Date(tm)
							const dt = new Date(this._chTimeMin)
							dt.setDate(1);
							dt.setMonth(0);
							dt.setHours(0, 0, 0, 0)
							return dt.getTime()
						} else if (zoomType == ZOOM_LAST) {
							//const dt = new Date(tm)
							const dt = new Date(this._chTimeMax)
							dt.setDate(1);
							dt.setMonth(0);
							dt.setHours(0, 0, 0, 0)
							return dt.getTime()
						}
					},

					zoomRngRight : function(tm) {
						const dt = new Date(tm)
						dt.setDate(1);
						dt.setHours(0, 0, 0, 0)
						dt.setMonth(0);
						dt.setFullYear(dt.getFullYear() + 1);
						return dt.getTime()
					},

                },
                YE : {
                    blk : 'years',
                    labelFmt : 'YE',
                    minusStep : tmblk.def.YE.minusStep,
					// u roku chceme v grafu zobrazovat vsechny data rovnou
					showAllData : true,
                    plusStep : function(tm) {
                        tm.setFullYear(tm.getFullYear() + 1)
                        return tm;
                    },
                },
            }

            if ( this.dataSe === null ) return

            let dd = def[this.chart_interval]
            if ( dd === null ) {
                console.log("Invalid chart_interval: ", this.chart_interval)
                return
            }

            let g1 = this.dataSe?.[this.chart_value]?.[dd.blk] || "?"
			if ( g1 == "?" ) {
				console.log("Not found in data - this.chart_value:" , this.chart_value)
				return
			}
            const tm0 = new Date(g1.tm0)
			let tmStart = new Date(tm0)
			for ( let i = 0; i < g1.blk.length; i++ ) {
                    tmStart = dd.minusStep(tmStart)
			}

            let tm = new Date(tm0)
            let gdata = []
            let chartOptions = null

            // pokud hodinovy graf, tak zkontroluj zda data nejsou starsi nez 1den
            // kdyz jsou starsi nezobrazuj nic
            function isDataOk(me) {
                if ( me.chart_interval == 'HO' ) {
                    const diff =  (new Date().getTime() - tm0.getTime()) / 1000
                    if ( diff > 60*60*24 ) {
                        return false
                    }
                }
                return true
            }


            // graf AVG (pocital jsem range min max za dane obdobi) nepouziva se
            if ( g1.dtype === 'AVG-range-off' ) {

				let lineData = []
				let areaData = []
                for ( let i = 0; i < g1.blk.length; i++ ) {
                    let c = g1.blk[i].c
					let v = 0
					let v1 = 0
					let v2 = 0
                    if ( c > 0 ) {
						v = g1.blk[i].v / c
                        v1 = g1.blk[i].m
                        v2 = g1.blk[i].x
						if ( !v1 || !v2 ) {
							v1 = v
							v2 = v1 + 1
						}
                        let it = { x : tm.getTime(), y : [v1.toFixed(1),v2.toFixed(1)] }
                        areaData.push(it)
                        it = { x : tm.getTime(), y : v.toFixed(1) }
                        lineData.push(it)
                    }
                    tm = dd.minusStep(tm)
                }


                const xmin = tm.getTime()
                const xmax = dd.plusStep(new Date()).getTime()
                const ymin = 0
                const ymax = 100
                const tooltipSuffix = ' %'
                const labelFmt = dd.labelFmt
                const dataLabels = this.chartLabelsEnabled
                if ( !isDataOk(this) ) {
                    areaData = []
                }
				const series = [
					{
						name: 'Min/Max',
						type: 'rangeArea',
                        data: areaData,
					},
					{
                        name: 'Průměr',
						type: 'line',
                        data: lineData,
					},
				]
                chartOptions = this.ChartBase( CHART_TYPE_MY_AREA, series, xmin, xmax, ymin, ymax, tooltipSuffix, labelFmt, dataLabels )

            // graf AVG
			} else if ( g1.dtype === 'AVG' ) {

                let convData = tmblk.AvgConvert( g1, this.chart_interval )
                if ( convData === false ) {
                    console.log("AvgConvert problem")
                    gdata = []
                }
                gdata = convData.data

                const xmin = tm.getTime()
                const xmax = dd.plusStep(new Date()).getTime()
                const ymin = 0
                const ymax = 100
                const tooltipSuffix = ' %'
                const labelFmt = dd.labelFmt
                const dataLabels = this.chartLabelsEnabled
                if ( !isDataOk(this) ) {
                    gdata = []
                }
				const series = [{
                        name: '',
						type: 'area',
                        data: gdata,
                    }]
                chartOptions = this.ChartBase( CHART_TYPE_MY_LINE, series, xmin, xmax, ymin, ymax, tooltipSuffix, labelFmt, dataLabels )

            // graf INCR
            } else if ( g1.dtype === 'INCR' ) {

                let vMax = 0
                // minus neni povoleno
                const minusAllowed = false
				
				let convFunc = null
				if ( this.chart_value == "g_locon_wh" ) {
					convFunc = function(v) { return v/1000 }
				}
                const convRet = tmblk.IncrConvert( g1, this.chart_interval, minusAllowed, convFunc )
                if ( convRet === false ) {
                    console.log("IncrConvert problem")
                    vMax = 0
                    gdata = []
                }
                gdata = convRet.data
                vMax = convRet.max

                const xmin = tm.getTime()
                const xmax = dd.plusStep(new Date()).getTime()
                const ymin = 0
                let ymax = Math.ceil(vMax)
				ymax = ymax + Math.ceil(ymax * 0.1)
                const tooltipSuffix = ' kWH'
                const labelFmt = dd.labelFmt
                const dataLabels = this.chartLabelsEnabled
                if ( !isDataOk(this) ) {
                    gdata = []
                    ymax = 10
				}
				const series = [{
                        name: '',
						type: 'area',
						//type: 'bar',
                        data: gdata,
                    }]
					chartOptions = this.ChartBase( CHART_TYPE_MY_LINE, series, xmin, xmax, ymin, ymax, tooltipSuffix, labelFmt, dataLabels )
					//chartOptions = this.ChartBase( CHART_TYPE_MY_BAR, series, xmin, xmax, ymin, ymax, tooltipSuffix, labelFmt, dataLabels )
            } else {
                console.log("Error - invalid type: ",g1.type)
                return 
            }

            if ( this.chart !== null ) {
                this.chart.destroy()
            }
            this.chart = new ApexCharts(this.$refs.chart, chartOptions)
            this.chart.render()

			// nastaveni default zoom
			dd._zoomSize = 0

			// kdyz chceme zobrazit cely range dat, je to potreba v pripade roku
			let allData = dd?.showAllData || false
			if ( this.chartShowAllData ) {
				allData = true
			}

			if ( allData ) {
				let zoomMax = new Date(tm0)
				let zoomMin = new Date(tm0)
				let valCnt = 0
				// plus jedna slouzi k tomu, pokud se jeste nepouzil cely rozsah hodnot 
				// tak chci vzit prvni hodnotu s nulou, jinak graf nevypada hezky, protoze 
				// zacina na prvni nenulove hodnote
				let plus1 = 0 
				for ( let i = gdata.length-1; i >= 0; i-- ) {
					valCnt = i
					const y = new Number(gdata[i].y)
					if ( y > 0 ) {
						zoomMax = gdata[i+plus1].x
						break
					}
					plus1 = 1
				}

				let zl = zoomMax
				let zr = zoomMin.getTime()
				// tady pripocitame posun pokud je dat malo
				let shiftLeft = 0
				let shiftRight = 0
				if ( valCnt < 10 ) {
					shiftLeft += zr - zl
					shiftRight += zr - zl
				}
				this.chart.zoomX(zl - shiftLeft,zr + shiftRight)

				// toto je zoom pro tlacitka kdyz skaceme
			} else if ( dd.zoomBlock ) {
				const zoomMax = new Date(tm0)
				let zoomMin = new Date(tm0)
				for ( let i = 0; i < dd.zoomBlock; i++ ) {
					zoomMin = dd.minusStep(zoomMin)
				}
				dd._chTimeMin = tmStart.getTime()
				dd._chTimeMax = zoomMax.getTime()
				dd._zoomSize = zoomMax.getTime() - zoomMin.getTime()
				//this.chart.zoomX(zoomMin.getTime(),zoomMax.getTime())

				const zl = dd.zoomRngLeft(ZOOM_LAST, zoomMax.getTime())
				const zr = dd.zoomRngRight(zl)
				this.chart.zoomX(zl,zr)

			}
			this.chartCurDef = dd

        },

		ChartScrollStart : function() {
			this.chartScrollFlag = true
		},
		ChartScrollStop : function() {
			this.chartScrollFlag = false
		},

		ChartFirstClick: function() {
			const dd = this.chartCurDef
			if ( !dd.zoomRngLeft ) {
				return
			}
			this.ChartScrollStart()
			const zl = dd.zoomRngLeft(ZOOM_FIRST, dd._chTimeMin)
			const zr = dd.zoomRngRight(zl)
			this.chart.zoomX(zl,zr)


		},
		ChartLeftClick: function() {
			const dd = this.chartCurDef
			if ( !dd.zoomRngLeft ) {
				return
			}

			this.ChartScrollStart()
			var curMin = this.chart.w.globals.minX
			let zl = dd.zoomRngLeft(ZOOM_LEFT, curMin)
			const zm = dd.zoomRngLeft(ZOOM_FIRST,null)
			if ( zl < zm ) {
				zl = zm
			}
			const zr = dd.zoomRngRight(zl)
			this.chart.zoomX(zl,zr)
		},
		ChartRightClick: function() {
			const dd = this.chartCurDef
			if ( !dd.zoomRngLeft ) {
				return
			}

			this.ChartScrollStart()
			var curMin = this.chart.w.globals.minX
			let zl = this.chartCurDef.zoomRngLeft(ZOOM_RIGHT, curMin)
			const zx = dd.zoomRngLeft(ZOOM_LAST,dd._chTimeMax)
			if ( zl >= zx ) {
				this.ChartScrollStop()
				zl = zx
			}
			const zr = this.chartCurDef.zoomRngRight(zl)
			this.chart.zoomX(zl,zr)
		},
		ChartLastClick: function() {
			const dd = this.chartCurDef
			if ( !dd.zoomRngLeft ) {
				return
			}

			this.ChartScrollStop()
			const zl = dd.zoomRngLeft(ZOOM_LAST, dd._chTimeMax)
			const zr = dd.zoomRngRight(zl)
			this.chart.zoomX(zl,zr)
		},

        ChLabelsEnabledChange: function() {
            this.ShowChart()
        },
        ChShowAllDataChange: function() {
            this.ShowChart()
        },
        ChValClick: function( t ) {
            this.chart_value = t
            this.ShowChart()
        },
        ChIntClick: function( t ) {
            this.chart_interval = t
            this.ShowChart()
        },
		DebugConAppend: function( msg ) {
			this.debugConsole = this.debugConsole + "\n" + msg
		},
		SetDataInterval: function( interval ) {
			this.dataInterval = interval
			this.refreshCnt = interval
			if ( interval === DATA_INTERVAL_DEFAULT ) {
				// pokud default interval nestavime nejake vyssi duration
				this.uwDuration = interval * 10
			}
		},
        UserWatchingModeClick: function() {
			this.ApiData()
			this.ctrlError = false
            libapi.Ctrl({ user_watching : 1}).then(
                (resp) => {
					/*
                if ( libapi.HandleEEError(resp) ) {
					this.ctrlError = true
                    return
					}
					 */
					if ( libapi.IsEEError(resp)) {
						this.ctrlError = true
						this.uwDuration = 0
						this.SetDataInterval(DATA_INTERVAL_DEFAULT)
					} else {
						this.uwDuration = resp?.data?.duration || 0
						this.SetDataInterval(resp?.data?.interval || DATA_INTERVAL_DEFAULT)
					}
                this.RefreshCntTimer()
            })

        },
        RefreshCntTimer: function() {
            this.timeNow = this.GetNow()
            if ( this.refreshCnt  > 0 ) {
                this.refreshCnt--
                this.uwDuration--
                if ( this.uwDuration < 1 ) {
					this.SetDataInterval(DATA_INTERVAL_DEFAULT)
                }
            } else {
                this.refreshCnt = 0
                this.ApiData()
            }
            clearTimeout(this.cntTo)
            this.cntTo = setTimeout(this.RefreshCntTimer, 1000)
            if ( this.dataSe == null ) {
                this.ApiData()
            }
        },
		IsDateToday : function( dt ) {
			let now = new Date()
			dt.setHours(0,0,0,0)
			now.setHours(0,0,0,0)
			return now.getTime() == dt.getTime()
		},
        GetDataErrMsg : function( arg ) {
            const errDef = [
                ["^DIF","Střídač"],
                ["^DCTINBA","Baterie řízení"],
                ["^DCTINEM","Elektroměr řízení"],
                ["^DSWBM","Baterie"],
            ]
            for (const i in errDef) {
                const v = errDef[i]
                const regex = new RegExp(v[0]);
                if ( regex.test(arg) ) {
                    return v[1]
                }
            }
            return null
        },
        ApiData: function() {
			// pokud je error tak nastavime default interval
			// jinak se nenastavi zadny a data se pri 403 stale obnovuji
			if ( this.isErrorApp ) {
				this.SetDataInterval(DATA_INTERVAL_DEFAULT)
			}
            libapi.Data().then(
                (resp) => {
                    if ( libapi.IsEEError(resp) ) {
						this.dataSe = null
						this.SetDataInterval(DATA_INTERVAL_DEFAULT)
                        return
                    }
                    this.dataSe = resp.data
					if ( Object.keys(this.dataSe).length === 0 ) {
						this.SetDataInterval(DATA_INTERVAL_DEFAULT)
                        return
					}

					let dayValFromChart = function( me, key ) {
						let blk = me.dataSe?.[key]?.days || false
						let ret = 0
						if ( blk !== false ) {
							let tm = me.dataSe?.[key]?.tm || false
							let dt = me.GetDateFromStrUTC(tm)
							if ( dt !== false && me.IsDateToday(dt) ) {
								const v1 = blk?.blk[0]?.v
								const v2 = blk?.blk[0]?.V
								ret = v2 - v1
							}
						}
						return ret
					}

					// vypocet kwh import za dnesni den
					this.emTodayKwh = dayValFromChart(this,"g_em_tot_kwh")

					// vypocet kwh export za dnesni den
					this.emExportTodayKwh = dayValFromChart(this,"g_em_tot_exp_kwh")

					// vypocet kwh spotreba za dnesni den
					this.loconDayKwh = dayValFromChart(this,"g_locon_wh")/1000

                    // vypocet chyb
                    // ------------
                    let errs = []
                    const stat = this.dataSe?.status?.devs || false
                    if ( stat ) {
                        for (const [k, v] of Object.entries(stat)) {
                            if ( v.error > 0 ) {
                                let msg = this.GetDataErrMsg(v.info)
                                if ( msg == null ) {
                                    msg = `Chyba: ${v.info}`
                                } else {
                                    msg = `Chyba: ${msg}`
                                }
                                errs.push({ devid : k, code : v.error, err : msg })
                            }
                        }
                    }
                    // prirazeni musi byt atomicke - protoze v IsDataError nastavujeme priznak do localStorage
                    this.dataErrors = errs
                    if ( this.dataErrors.length == 0 ) {
                        this.dataErrorsTs = new Date()
                    }


					if ( !this.chartScrollFlag ) {
						this.ShowChart()
					}

                    this.refreshCnt = this.dataInterval
                })
        },

        HandleVisibilityChange() {
            if (document.hidden) {
                clearTimeout(this.cntTo)
            } else {
                this.UserWatchingModeClick()
            }
        },
    },

    mounted: function() {
        this.UserWatchingModeClick()
        document.addEventListener('visibilitychange', this.HandleVisibilityChange)
    },
	beforeUnmount: function() {
        clearTimeout(this.cntTo)
        if (this.chart) {
            this.chart.destroy()
        }
        document.removeEventListener('visibilitychange', this.HandleVisibilityChange)
	},
}
</script>

<style>
    .my-td-vam {
        vertical-align:middle !important;
    }
	.my-line-h1 {
		line-height: 1
	}
</style>
